import { render } from "./editStockAllocation.vue?vue&type=template&id=1ef8f2fc&scoped=true"
import script from "./editStockAllocation.vue?vue&type=script&lang=js"
export * from "./editStockAllocation.vue?vue&type=script&lang=js"

import "./editStockAllocation.vue?vue&type=style&index=0&id=1ef8f2fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef8f2fc"]])

export default __exports__